import { render, staticRenderFns } from "./EmbeddedList.vue?vue&type=template&id=46182140&scoped=true&"
import script from "./EmbeddedList.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedList.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedList.vue?vue&type=style&index=0&id=46182140&lang=less&scoped=true&"
import style1 from "./EmbeddedList.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46182140",
  null
  
)

export default component.exports